import {BaseEffect} from './base.effect';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {SendBackResult} from '../models/send-back-result';
import {ArrayResponse} from '../models/array-response';
import {Router} from '@angular/router';
import {debug} from '../../../rxjs-operators';
import {catchError, map, switchMap} from 'rxjs/operators';
import {Product} from '../models/product';
import {LoadProductsByServiceAction, LoadProductsFailAction, LoadProductsSuccessAction, productsActionTypes} from '../actions/product';
import {error} from '..';
import {ProductsService} from '../services/products-List.service';
import {L10nTranslationService} from 'angular-l10n';
import {ReturnPlayerUpdateStatusAction} from '../actions/anomaly-player-return';
import {ApiCacheService} from '../services/cache.service';
import {of} from 'rxjs';

@Injectable()
export class ProductsEffect extends BaseEffect {


  load$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(productsActionTypes.LOAD),
      debug('Products load action received.'),
      switchMap(() => {
        const cacheKey = 'products';
        const cached = this.apiCacheService.get<Product[]>(cacheKey);

        if (cached) {
          return of(new LoadProductsSuccessAction(cached));
        }

        return this.productsService.getList().pipe(
          map((payload: SendBackResult<ArrayResponse<Product>>) => {
            const products = payload.data.array;
            this.apiCacheService.set(cacheKey, products);
            return new LoadProductsSuccessAction(products);
          }),
          catchError(res => this.catchResponseError(res))
        );
      })
    );
  });
  // loadByService$ = createEffect(() => { return this.actions$.pipe(
  //   ofType(productsActionTypes.LOAD_BY_SERVICE),
  //   debug('Products load action received.'),
  //   map((action: LoadProductsByServiceAction) => action.payload),
  //   switchMap((serviceID) => this.productsService.getListByService(serviceID).pipe(
  //     map((payload: SendBackResult<ArrayResponse<Product>>) => new LoadProductsSuccessAction(payload.data.array)),
  //     catchError(res => this.catchResponseError(res)),
  //   )),
  // ) });

  loadByService$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(productsActionTypes.LOAD_BY_SERVICE),
      debug('Products load action received.'),
      map((action: LoadProductsByServiceAction) => action.payload),
      // tslint:disable-next-line:no-any
      switchMap((serviceID: any) => {
        const cacheKey = `products_by_service_${serviceID}`;
        const cached = this.apiCacheService.get<Product[]>(cacheKey);

        if (cached) {
          return of(new LoadProductsSuccessAction(cached));
        }

        return this.productsService.getListByService(serviceID).pipe(
          map((payload: SendBackResult<ArrayResponse<Product>>) => {
            const products = payload.data.array;
            this.apiCacheService.set(cacheKey, products);
            return new LoadProductsSuccessAction(products);
          }),
          catchError(res => this.catchResponseError(res))
        );
      })
    );
  });
  loadFail$ = createEffect(() => { return this.actions$.pipe(
    ofType(productsActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving products list.'),
    map((action: LoadProductsFailAction) =>
      error(this.translation.translate('PRODUCTS_LOAD_ERROR') + '  ' + action.payload, this.translation.translate('TOAST_ERROR_TITLE')))
  ) });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private productsService: ProductsService,
              private apiCacheService: ApiCacheService,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadProductsFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadProductsFailAction(response['error'].message);
  }
}
